import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';

export async function refreshToken(user_id, access_token) {

  /* global API_BASE_URL */
  const url = API_BASE_URL + '/cas/refresh_token';

  const baseRequestConfig = getBaseRequestConfig();

  const requestConfig = Object.assign({}, baseRequestConfig, {
    method: 'POST',
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({
      user_id,
      access_token
    })
  });

  const response = await asyncFetch(url, requestConfig);
  return await response;
}



/** WEBPACK FOOTER **
 ** ./src/connectivity/api.auth.js
 **/